import Ben1Thumb from "./assets/ben1.jpg";
import Ben1Video from "./assets/ben1.mp4";
import Doc1Thumb from "./assets/doc1.jpg";
import Doc1Video from "./assets/doc1.mp4";
import Sha1Thumb from "./assets/sha1.jpg";
import Sha1Video from "./assets/sha1.mp4";

export default [
  {
    thumb: Ben1Thumb,
    video: Ben1Video,
    ar: {
      title: "مستر بين",
      desc:
        "مستر بين هوَ مسلسلٌ بريطانيّ كوميدي من تأليف روان أتكينسون وريتشارد كورتيس، ومن بطولَة أتكينسون في الدور الرئيسي. يتكوّن المسلسل من 15 حَلقة"
    },
    en: {
      title: "Mr Bean series 1",
      desc:
        "Mr. Bean is a British sitcom created by Rowan Atkinson and Richard Curtis, produced by Tiger Aspect and starring Atkinson as the title character. The sitcom consisted of 15 episodes"
    }
  },
  {
    thumb: Doc1Thumb,
    video: Doc1Video,
    ar: {
      title: "ما هي قدرات الذكاء الصناعي؟ | وثائقية دي دبليو",
      desc:
        "يقود التطور في مجال الذكاء الصناعي إلي تغيير أساسي. إذ تستطيع اللوغاريتمات حاليا التعرف على السرطان أو مرض باركنسون، وتتحكم بالطائرات والسيارات. ماذا ينتظرنا؟ كيف سيغير الذكاء الصناعي مجتمعنا؟"
    },
    en: {
      title: "Artificial intelligence & algorithms: pros & cons",
      desc:
        "Developments in artificial intelligence (AI) are leading to fundamental changes in the way we live. Algorithms can already detect Parkinson's disease and cancer, and control both cars and aircraft. How will AI change our society in the future?"
    }
  },
  {
    thumb: Sha1Thumb,
    video: Sha1Video,
    ar: {
      title: "محمد متولي الشعراوي",
      desc:
        "عالم دين ووزير أوقاف مصري سابق. يعد من أشهر مفسري معاني القرآن الكريم في العصر الحديث؛ حيث عمل على تفسير القرآن الكريم بطرق مبسطة وعامية مما جعله يستطيع الوصول لشريحة أكبر من المسلمين في جميع أنحاء العالم العربي، لقبه البعض بإمام الدعاة."
    },
    en: {
      title: "Muhammad Metwalli al-Sha'rawi",
      desc:
        'was a Muslim scholar, former Egyptian minister of Endowments and Muslim jurist. He has been called one of Egypt\'s most popular and successful Islamic preachers, and "one of the most-prominent symbols of popular Egyptian culture" in the 1970s, 1980s and 1990s'
    }
  }
];
